import React from "react";
import SectionHeading from "components/SectionHeading";
import classes from "../style.module.scss";
import TermsAndConditionsContent from "./Content";

export default () => (
    <div>
        <SectionHeading title="Terms & Conditions" subtitle="Terms governing use of the Volta SNAP platform." />
        <div className={classes.contentWrapper}>
            <TermsAndConditionsContent />
        </div>
    </div>
);
